import BarChart, { BarChartProps } from './BarChart.component';

export type PieChartType = BarChartProps;

export default BarChart;
